/**
 * @module components\ghPdf
 */
import Vue from "vue";
import Component from "vue-class-component";
import pdf from "vue-pdf";
import { API_BASE_URL } from "@/utils/conf";
import { Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    pdf
  }
})
export default class GhPdf extends Vue {
  @Prop()
  private id!: string;

  private url = API_BASE_URL + "api/files/";

  private get src() {
    if (this.id) {
      return this.url + this.id;
    }
    return undefined;
  }

  // @Watch("id")
  // private loading() {
  //   if (this.src) {
  //     this.src.then(pdf => {
  //       this.numPages = pdf.numPages;
  //     });
  //   }
  // }
  mounted() {}
  private currentPage = 1;
  private pageCount = 0;

  private next() {
    this.currentPage = this.currentPage + 1;
  }

  private pre() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
    }
  }
  // private numPages = 0;
}
